import { Button, Form, Input, Select } from "antd";
import React from "react";
import "./styles.scss";

const ContactForm = () => {
  const [form] = Form.useForm();
  const { Option } = Select;
  const { TextArea } = Input;
  const handleSubmit = (values) => {
    console.debug("form values>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", values);
  };
  return (
    <section className="contact-us-form">
      <div className="section-title-text">Contact us</div>
      <div className="section-title-desc">
        Ask about our games, find answers to your questions and get in touch.
      </div>
      <section className="form-address-container">
        <section className="addres-section">
          <div className="address-heading-text">ShiftedPixel Games</div>
          <div className="first-address">St. John's NL, Canada</div>
          <div className="first-address">contact@shiftedpixel.io</div>
        </section>
        <section className="form-container">
          <Form form={form} onFinish={handleSubmit}>
            <Form.Item name="Select">
              <Select defaultValue="general-qusetions">
                <Option value="general-qusetions">General Qusetions</Option>
                <Option value="coperation">Coperation</Option>
                <Option value="publishing">Publishing</Option>
                <Option value="press-media">Press and Media</Option>
                <Option value="support">Support</Option>
                <Option value="careers">Careers</Option>
              </Select>
            </Form.Item>
            <Form.Item value="first_name" name="first_name">
              <Input placeholder="First Name" />
            </Form.Item>
            <Form.Item value="last_name" name="last_name">
              <Input placeholder="Last Name" />
            </Form.Item>
            <Form.Item value="company" name="company">
              <Input placeholder="Company" />
            </Form.Item>
            <Form.Item value="email" name="email">
              <Input placeholder="Email Address" />
            </Form.Item>
            <Form.Item value="website" name="website">
              <Input placeholder="Website Url (Optional)" />
            </Form.Item>
            <Form.Item value="phone" name="phone">
              <Input placeholder="Phone (Optional)" />
            </Form.Item>
            <Form.Item value="help" name="help">
              <TextArea rows={8} placeholder="How can we help?" />
            </Form.Item>
            <Form.Item>
              <Button block htmlType="submit" className="more-games-btn">
                Send
              </Button>
            </Form.Item>
          </Form>
        </section>
      </section>
    </section>
  );
};

export default ContactForm;
